import api from './api';

export default {

    getTeamCompetition(page=1,search=false, sort='asc'){
        return api.get(`${process.env.VUE_APP_URL}/competitions/user/teams` , {params: {search:search , sort:sort , page:page}});
    },
    getIndividualCompetition(page=1,search=false, sort='asc'){
        return api.get(`${process.env.VUE_APP_URL}/competitions/user/individual` , {params: {search:search , sort:sort , page:page}});
    },
    indexIndividual(search=false, sort='asc', page=1){
        return api.get(`${process.env.VUE_APP_URL}/competitions/gotAnswers` , {params: {search:search , sort:sort , page:page}});
    },
    usersOfCompetition(id , search=false, sort='asc',page=1){
        return api.get(`${process.env.VUE_APP_URL}/competitions/usersAnswered/${id}` , {params: {search:search , sort:sort , page:page}});
    },
    teamsOfComeptition(id){
        return api.get(`${process.env.VUE_APP_URL}/competitions/show-teams/${id}`);
    },
    getUsersInTeams(id1,id2){
        return api.get(`${process.env.VUE_APP_URL}/competitions/members-solved/${id1}/${id2}`);
    },
    indexTeam(search=false, sort='asc', page=1){
        return api.get(`${process.env.VUE_APP_URL}/competitions/Assigned-to-teams` , {params: {search:search , sort:sort , page:page}});
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/get/competitionData/${id}`);
    },
    showUserCompetitionAnswers(competition_id , user_id){
        return api.get(`${process.env.VUE_APP_URL}/get/competitionData/${competition_id}/${user_id}`);
    },
    storeScoreCompetition(id,bonus,user_score,free_text_score,rank_score,user_id,type,params){
        return api.post(`${process.env.VUE_APP_URL}/store/user/score/${id}/${user_score}/${free_text_score}/${rank_score}/${bonus}/${user_id}/${type}` , params);
    },
    getCompetitionScoreData(id,user_id){
        return api.get(`${process.env.VUE_APP_URL}/get/competition/score/${id}/${user_id}`);
    }
}